import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import SettingsPanel from "./settingsPanel";
import { alertActions, commonActions } from "../../_actions";
import { commonService } from "../../_services/common.service";
// core components
import moment from "moment";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
// import Table from "components/Table/Table.jsx";
import { connect } from "react-redux";
import { appConstants } from "../../_constants";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import TableStructure from "./airlineViewTable";
import CircularProgress from "../../utils/CircularProgress";

const presentDate = new Date();
let date = new Date();
let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

const styles = (theme) => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  negativeColor: {
    color: "red",
  },
  positiveColor: {
    color: "green",
  },
  nb: {
    color: "red",
    fontSize: "12px",
  },
  wide: {
    width: "100%",
    minWidth: "300px",
  },
});

class ExchangeRateAirlineView extends React.Component {
  state = {
    response: "",
    open: false,
    recordCreatedBy: "",
    ApprovedBy: "",
    ExchangeData: [],
    pendingExchangeData: [],
    openModal: false,
    currentExchange: "",
    errorMessage: "",
    errorComponent: false,
    editErrorComponent: false,
    users: [],
    currentPage: 1,
    currentPagePending: 1,
    totalCount: 0,
    error: false,
    formError: "",
    reason: "",
    comment: "",
    Status: 0,
    openComment: false,
    pageSize: 10,
    date: new Date(),
    startDate: firstDay, //first day of the current month
    endDate: presentDate, //End date by default will always be current date
    DateType: 0,
    invoiceNumber: "",
    createdBy: "",
    notCreatedBy: "",
    approvedBy: "",
    newExchangeRate: 0,
    EffectiveDate: "",
    isApprove: false,
    isReject: false,
    currentExchangeRate: [],
    todayExchangeRate: 0
  };

  componentDidMount() {
    let { users, dispatch } = this.props;
    if (users) {
      this.setState({ users: users.ResultList });
    } else {
      dispatch(commonActions.getAllUsers());
    }
    this.getCurrentExchangeRate();
  }

  componentWillReceiveProps = function(nextProps) {
    const { airlines, users } = nextProps;
    if (airlines) {
      this.setState({ airlinesData: airlines.Results });
    }
    if (users) {
      this.setState({ users: users.ResultList });
    }
  };

  //Get Exchange Rate
  getCurrentExchangeRate = (pageNumber = 0) => {
    const { dispatch } = this.props;
    const { pageSize, startDate, endDate } = this.state;
    let payload = {
      pageSize: pageSize,
      From: pageNumber === 0 ? 0 : (pageNumber - 1) * pageSize,
      Parameter: {
        StartDate: moment(startDate).format("YYYY-MM-DD"),
        EndDate: moment(endDate).format("YYYY-MM-DD"),
      },
    };

    dispatch(alertActions.startRequest());
    commonService.searchExchangeRateRegional(payload).then((res) => {
      dispatch(alertActions.stopRequest());
      let response = res.response;

      if (res.status === appConstants.SUCCESS_RESPONSE) {
        // dispatch(alertActions.notify("Resources Found"))
        let results = response.Results;
        this.setState({
          totalCount: response.TotalCount,
          currentExchangeRate: results,
          todayExchangeRate: response.ExchangeRateToday,
          currentPage: pageNumber === 0 ? 1 : pageNumber,
        });
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
      }
    });
  };

  //Handle Input
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  filterUsers = (userId) => {
    const { users } = this.state;
    if (users) {
      let userName = users.find((u) => u.Id === userId);
      if (userName) {
        return `${userName.FirstName} ${userName.LastName}`;
      } else {
        return "Unknown User"; //`Unknown User`;
      }
    }
  };

  handleDateChange = (date, target) => {
    this.setState({ [target]: date });
  };

  render() {
    const { classes, requesting } = this.props;
    const {
      pageRequesting,
      newExchangeRate,
      formError,
      startDate,
      endDate,
      error,
      errorComponent,
      errorMessage,
      currentExchange,
      openModal,
      currentExchangeRate,
      date,
      todayExchangeRate
    } = this.state;

    if (pageRequesting) return <CircularProgress />;
    return (
      <div>
        <GridContainer>
          <SettingsPanel
            errorComponent={errorComponent}
            formError={formError}
            error={error}
            errorMessage={errorMessage}
            openModal={openModal}
            handleChange={(event) => this.handleChange(event)}
            handleExchangeRate={this.handleExchangeRate}
            currentExchange={currentExchange}
            handleSearch={this.getCurrentExchangeRate}
            newExchangeRate={newExchangeRate}
            todayExchangeRate={todayExchangeRate}
            date={date}
            dateLabel={"Date"}
            startDate={startDate}
            endDate={endDate}
            startLabel="Start Date"
            endLabel="End Date"
            handleDateChange={this.handleDateChange.bind(this)}
            disabled={requesting}
          />
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="regional">
                <h4 className={classes.cardTitleWhite}>Exchange Rate</h4>
              </CardHeader>
              <CardBody>
                <div className={classes.tableResponsive}>
                  <TableStructure
                    records={currentExchangeRate}
                    classes={this.props.classes}
                    totalCounts={this.state.totalCount}
                    filterUsers={this.filterUsers}
                    currentPage={this.state.currentPage}
                    pageSize={this.state.pageSize}
                    user={this.props.user}
                    fetchMore={this.getCurrentExchangeRate}
                  />
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

ExchangeRateAirlineView.defaultProps = {
    tableHeaderColor: "gray"
};

ExchangeRateAirlineView.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray",
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
};
const mapStatesToProps = (state) => {
  const { modal, alert, airlines, progress, user, users, requesting } = state;
  return {
    modal,
    alert,
    airlines,
    progress,
    user,
    users,
    requesting,
  };
};

export default connect(mapStatesToProps)(withStyles(styles)(ExchangeRateAirlineView));



// WEBPACK FOOTER //
// ./src/Regional-Views/ExchangeRateAirline/airlineView.js